// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

export function popOverOverlayPosition(
    targetBounds: DOMRect,
    innerHeight: number,
    spaceRequiredAbove: number,
    spaceRequiredBelow?: number,
    topOffset: number = 0,
    horizontalPosition?: 'left' | 'right'): string {
    let placement: string;

    if (targetBounds.top - topOffset > spaceRequiredAbove) {
        placement = 'top';
    } else if (innerHeight - targetBounds.bottom - topOffset > (spaceRequiredBelow || spaceRequiredAbove)) {
        placement = 'bottom';
    } else {
        placement = horizontalPosition || 'left';
    }
    return placement;
}
